export default {
      id: "plug-white-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#plug-white",
      toString: function () {
        return this.url;
      }
    }